import React from 'react'

import FacebookIcon from '../../../images/facebook.svg'
import InstagramIcon from '../../../images/instagram.svg'
import TwitterXIcon from '../../../images/twitter-x.svg'

const ModalSocial = () => {
  return (
    <div className="modal__social">
      <a aria-label="Facebook" target="_blank" href="https://www.facebook.com/mealpal" rel="noreferrer">
        <img src={FacebookIcon} height="30" width="30" />
      </a>
      <a aria-label="Instagram" target="_blank" href="https://www.instagram.com/mealpal/" rel="noreferrer">
        <img src={InstagramIcon} height="30" width="30" />
      </a>
      <a aria-label="Twitter" target="_blank" href="https://x.com/mealpal" rel="noreferrer">
        <img src={TwitterXIcon} height="30" width="30" />
      </a>
    </div>
  )
}

export default ModalSocial
